export default "__VITE_ASSET__0639ca40__"